import OrganizationBannerLoader from './OrganizationBannerLoader';

interface IOrganizationPageTemplate {
    children: React.ReactNode;
}
export default function OrgPageTemplate({ children }: IOrganizationPageTemplate) {
    return (
        <>
            <OrganizationBannerLoader />
            {children}
        </>
    );
}
